import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { formatNumber } from '@atc/string-fns';
import { Button, Heading, StarRating, SubHeading, Text } from 'reaxl';
import { deprecate } from 'react-is-deprecated';
import RatingBreakdown from '../RatingBreakdown';
function ConsumerRatings(_ref) {
  let {
    heading,
    onReviewsDetailClick = () => {},
    overallRating,
    ratings,
    ratingBarsClassName,
    // deprecated
    ratingBreakdownClassName,
    reviewCounts,
    title,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "consumerRatings"
  }, rest), heading && /*#__PURE__*/_jsx(Heading, {
    level: 2
  }, void 0, heading), title && /*#__PURE__*/_jsx(SubHeading, {
    level: 3
  }, void 0, title), /*#__PURE__*/_jsx("div", {
    className: "display-flex align-items-center gap-3 margin-top-3"
  }, void 0, overallRating && /*#__PURE__*/_jsx(Text, {
    size: 700,
    weight: "bold"
  }, void 0, overallRating.toFixed(1)), /*#__PURE__*/_jsx("div", {
    className: "line-height-sm"
  }, void 0, /*#__PURE__*/_jsx(StarRating, {
    value: overallRating,
    color: "#e8bb38",
    className: "text-size-500"
  }), /*#__PURE__*/_jsx(Text, {
    componentClass: "div",
    size: 200,
    weight: "bold"
  }, void 0, "Consumer Rating", reviewCounts && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/_jsx(Button, {
    className: "text-normal",
    bsStyle: "text",
    onClick: onReviewsDetailClick
  }, void 0, `(${formatNumber({
    value: reviewCounts
  })} reviews)`))))), /*#__PURE__*/_jsx(RatingBreakdown, {
    className: ratingBarsClassName || ratingBreakdownClassName,
    ratings: ratings
  }));
}
export default /*#__PURE__*/memo(ConsumerRatings);